<article class="row bg-white">
  <aside class="col-3 p-5">
    <h5 class="font-weight-bold mb-3">Contenido</h5>
    <ul class="p-0">
      <li class="list-unstyled pointer mb-1" *ngFor="let item of faq" [ngClass]="!item.isCollapse? 'active' : ''" (click)="onCollase(item)">{{item.faq_seccion_descripcion.charAt(0).toUpperCase() + item.faq_seccion_descripcion.slice(1).toLowerCase()}}</li>
      <li class="list-unstyled pointer mb-1" *ngFor="let item of terminos" [ngClass]="!item.collapse? 'active' : ''" (click)="onCollase(item)">{{item.titulo.charAt(0).toUpperCase() + item.titulo.slice(1).toLowerCase()}}</li>
    </ul>
  </aside>
  <section class="col-9 p-5">
      <ng-content></ng-content>
  </section>
</article>